module.exports = __webpack_public_path__ + "static/media/kanban.dd686200.svg";